import * as Vue from "vue"
import * as mutations from "../../mutation-types"

export const toggleSidebar = (store) => {
    store.commit(mutations.TOGGLE_SIDEBAR)
}

export const closeSidebar = (store) => {
    if(document.documentElement.clientWidth < 1023) {
        store.commit(mutations.CLOSE_SIDEBAR)
    }
}